import React from 'react'
// import ControlManagement from '../Controlmanagement';
import { Link } from 'react-router-dom';
import Cateringsubscriptiondata from "./Cateringsubscriptiondata";
import Bannerspage from "../Food/Bannerspage";
import Aboutsubscription from "../Food/Aboutsubscription";
const Cateringsubscription = () => {
    return (
        <div>
            <p
                className="breadcrumb maamaas-home-bredcum or7"
                style={{
                    position: "fixed",
                    top: "38px",
                    left: "1vw",
                    width: "100%",
                    backgroundColor: "#fff",
                    // zIndex: 1000,
                    padding: "30px 0",
                    fontSize: "18px",
                    fontWeight: "bold",
                    textAlign: "center",
                    margin: 0,
                    height: "80px",
                }}
            >
                <Link
                    to="/Homes"
                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    Home
                </Link>
                {/* <span className="separator"> &gt; </span>
                                         <Link
                                           to="/Busineesnetwork"
                                           style={{
                                             color: "rgb(41 10 70)",
                                             fontWeight: "bold",
                                             textDecoration: "none",
                                           }}
                                         >
                                           Business
                                         </Link> */}
                <span className="separator"> &gt; </span>
                <span
                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    Subscription_Managment
                </span>
                <span className="separator"> &gt; </span>
                <span
                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    Catering & Services
                </span>
                {/* <span className="separator"> &gt; </span> */}

            </p>
            <div style={{ height: "600px", marginTop: "100px", overflow: "auto", scrollbarWidth: "none" }} className='banners-subscription-data-page'>
                <Bannerspage />
                <Aboutsubscription />
                <Cateringsubscriptiondata />
            </div>
        </div>
    )
}

export default Cateringsubscription;
